import { __awaiter, __generator } from "tslib";
export var createUserAvatarDriver = function (wrapper) {
    var base = wrapper.$(".user-avatar");
    return {
        getInitials: function () { return base.$('.inner').text(); },
        isProfileImgVisible: function () { return base.$('img').exists(); },
        isInitialsVisible: function () { return base.$('.initials').exists(); },
        isUserBadgeVisible: function () { return base.$('.user-badge').exists(); },
        isStatusVisible: function () { return base.$('.status-indicator').exists(); },
        getProfileImgUrl: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, base.$('img').attr('src')];
                case 1: return [2 /*return*/, (_a.sent()) || ''];
            }
        }); }); },
    };
};
//# sourceMappingURL=driver.js.map